export default {
    buscando: false,
    items: [],
    cpe: []
}